<template>
  <div class="bill-list">
    <van-sticky>
      <van-nav-bar :border="false">
        <template #left>
          <span class="iconfont icon-houtui fs-24 fw-700" @click="$router.back()"></span>
        </template>
        <template #title>
          <strong>代理账单音乐人明细</strong>
        </template>
      </van-nav-bar>
    </van-sticky>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
      ><div class="card-list">
        <div v-for="item in music" :key="item.uid" class="mr-card mt-10">
          <div class="title">
            <strong>{{ item.label }}: {{ item.name }} ({{ item.company_id === 1 ? '渠道一' : '渠道二' }})</strong>
            <div class="flex align-center"> 账单时间：<span>{{ item.bill_time }}</span> </div>
          </div>
          <div class="content">
            <div><strong class="fs-14">收益金额: {{ item.income | formatAmount }}</strong></div>
          </div>
        </div>
        </div>
        <template v-if="music.length > 0" #finished>
          <span>没有更多了</span>
        </template>
        <van-empty v-if="music.length === 0" description="暂无数据" />
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import Filter from '@/filters/index'
import { getAgentBillMusic } from '@/api/agent.js'
export default {
  name: 'BillList',
  data() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      show: false,
      date: '',
      currentPage: 0,
      music: [],
      uid: ''
    }
  },
  computed: {
    filterTime() {
      const name = Filter.formatTime(this.date, '{y}-{m}') === Filter.formatTime(new Date(), '{y}-{m}') ? '本月' : Filter.formatTime(this.date, '{y}-{m}')
      return name
    }
  },
  async created() {
    this.date = this.$route.query.time
    this.uid = this.$route.query.uid
  },
  methods: {
    async getAgentBillMusic(type) {
      const res = await getAgentBillMusic({ page: this.currentPage, updatetime: Filter.formatTime(this.date, '{y}-{m}'), uaid: this.uid })
      const data = res.data
      this.currentPage = +data.current_page // 隐士转化为Number类型
      const list = data.data.map(val => ({
        label: '账单SP',
        name: val.sp_name,
        income: val.income,
        company_id: val.company_id,
        bill_time: val.bill_time
      }))
      if (type === 'refresh') { // 下拉刷新
        this.music = list
      } else { // 上拉加载
        this.music = [...this.music, ...list]
      }
      return list.length
    },
    async onRefresh() {
      this.currentPage = 1
      await this.getAgentBillMusic('refresh')
      this.$toast('刷新成功')
      this.isLoading = false
      this.finished = false
    },
    async onLoad() {
      this.loading = true
      this.currentPage = this.currentPage + 1
      const length = await this.getAgentBillMusic()
      if (length < 1) {
        this.finished = true
      }
      this.loading = false
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    }
  }
}
</script>

<style lang="scss" scoped>
.bill-list{
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  height: auto;
  /deep/ .van-pull-refresh__track{
    min-height: calc(100vh - 46Px);
  }
}
.card-list{
  padding: 0 15px;
}
.mr-card{
  font-size: 12px;
  border-radius: 15px;
  box-shadow: 0 0 5px 0 rgb(206, 204, 204);
  .title{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    border-bottom: 1px solid #E0E2E7;
    a{
      color: inherit;
    }
  }
  .content{
    padding: 20px 16px 30px;
    .count{
      display: flex;
      flex-wrap: wrap;
      .count-item{
        width: 50%;
        color: #9DA4B3;
        margin-bottom: 6px;
      }
    }
  }
}
</style>
